module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@bottlebooks/gatsby-theme-event/gatsby-browser.js'),
      options: {"plugins":[],"rootPath":"/","homePath":"/exhibitors","exhibitorBase":"exhibitors","producerBase":"producers","productBase":"products","locale":"en","eventId":"5ecfcccc9bffeb13f54640f3"},
    }]
